import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { GovernorateService } from '../../../../../app/shared/API-Service/services/governorate.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'

@Component({
  selector: 'app-view-governorate',
  templateUrl: './view-governorate.component.html',
  styleUrls: ['./view-governorate.component.css']
})
export class ViewGovernorateComponent implements OnInit {
  governorate:object [] = [];
  img : string = Image;
  constructor(private _GovernorateService:GovernorateService,private _Router:Router) { }

  ngOnInit(): void {
    this.getgovernorates();
  }
  getgovernorates(){
    this._GovernorateService.GetGovernorate().subscribe((res) => {
      this.governorate = res.data
    console.log(this.governorate);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  update(data){
    this._GovernorateService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertGovernorate']);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._GovernorateService.DeleteGovernorate(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getgovernorates();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
